// Creating canvas
const createCanvas = () => {
    let elem = document.createElement('canvas');
    let container = document.querySelector('.theme-container');
    elem.classList.add('canvasAnimation');
    container.appendChild(elem); 
}

// Showing image on random position
const showAnimation = () => {
    const errorImg = document.querySelector('.error .error__img').src;
    const canvas = document.querySelector('.canvasAnimation');
    const img = new Image();
    const ctx = canvas.getContext('2d');
    let x, y, height, width;

    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    if (screen.width > 768) {
        width = 91;
        height = 73;
    } else {
        width = 80;
        height = 64;
    }
    
    const drawImg = () => {
        setTimeout(function() {
            // Setting random x and y coordinates for the image.
            x = Math.floor(Math.random() * canvas.width);
            y = Math.floor(Math.random() * canvas.height);
            img.src = errorImg;
            img.onload = () => {
                ctx.drawImage(img, x, y, width, height);
            }
            requestAnimationFrame(drawImg);
        }, 1000);
    } 
    drawImg(); 
}

export const canvasAnimation = () => {
    // Adding initial delay of 1s (Total intital delay becomes 2s due to setInterval of showAnimation())
    setTimeout(() => {
        createCanvas();
        showAnimation();
    }, 1000)
}
